import clsx from "clsx";

import styles from "./holidays-hero.module.css";

const HERO_ILLUSTRATION = "/assets/images/Holiday_Icon.png";

export function HolidaysHero() {
  return (
    <section className={styles.hero} aria-labelledby="holidays-hero-heading">
      <div className={styles.row}>
        <div className={styles.copy}>
          <h1 id="holidays-hero-heading" className={clsx("heading-lg", styles.title)}>
            Holiday Calendar
          </h1>
          <p className={clsx("sub-heading-sm", styles.subtitle)}>
            Approved holidays by region and year
          </p>
        </div>
        <div className={styles.art} aria-hidden>
          <img
            src={HERO_ILLUSTRATION}
            alt=""
            className={styles.heroImg}
            width={320}
            height={160}
            decoding="async"
          />
        </div>
      </div>
    </section>
  );
}
